import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { CreatePatientForm } from "types";

import ConsentFormUpload from "./ConsentFormUpload";

function ConsentDocumentsSection() {
  const {
    formState: { errors },
  } = useFormContext<CreatePatientForm>();

  const consentForms = [
    {
      name: "hipaaConsentForm" as keyof CreatePatientForm,
      title: "HIPAA Consent Form",
      description:
        "Patient consent for use and disclosure of health information",
      error: errors.hipaaConsentForm?.message as string,
    },
    {
      name: "treatmentConsent" as keyof CreatePatientForm,
      title: "Treatment Consent",
      description: "Consent to receive medical treatment",
      error: errors.treatmentConsent?.message as string,
    },
    {
      name: "financialAgreement" as keyof CreatePatientForm,
      title: "Financial Agreement",
      description: "Agreement to pay for services",
      error: errors.financialAgreement?.message as string,
    },
  ];

  return (
    <Box className="space-y-6 mt-8">
      <Typography variant="h6" className="text-xl font-medium">
        Consent & Documents
      </Typography>

      <Typography variant="body2" className="text-gray-600 mb-4">
        Required Consent Forms
      </Typography>

      <Box className="grid grid-cols-3 gap-4">
        {consentForms.map((form) => (
          <ConsentFormUpload
            key={form.name}
            name={form.name}
            title={form.title}
            description={form.description}
            error={form.error}
          />
        ))}
      </Box>
    </Box>
  );
}

export default ConsentDocumentsSection;
